import React, {Component} from 'react'
import PropTypes from 'prop-types'
import PageHeader from '../components/PageHeader/index'
import {RouteContext} from '../utils/context'

class PageHeaderLayout extends Component {
    render() {
        const {children, title, content, ...restProps} = this.props
        return (
            <div>
                <RouteContext.Consumer>
                    {({routes, location}) => <PageHeader title={title} content={content} routes={routes}
                                                         location={location} {...restProps} />}
                </RouteContext.Consumer>
                <div style={{margin: '24px 24px 0'}}>
                    {children}
                </div>
            </div>
        )
    }
}

PageHeaderLayout.propTypes = {
    title: PropTypes.string,
    content: PropTypes.node,
};

export default PageHeaderLayout